export const SUPPORTED_LANGUAGES = ['fr', 'en', 'ja', 'de', 'no', 'tr', 'zh', 'es', 'th', 'cs', 'is']

export const DEFAULT_LANGUAGE = 'en'

export const LANGUAGE_LOCALES = {
    fr: 'fr-FR',
    en: 'en-GB',
    ja: 'ja-JP',
    de: 'de-DE',
    no: 'nb-NO',
    tr: 'tr-TR',
    zh: 'zh-CN',
    es: 'es-ES',
    th: 'th-TH',
    cs: 'cs-CZ',
    is: 'is-IS',
}

export const LANGUAGE_NAMES = {
    fr: 'Français',
    en: 'English',
    ja: '日本語',
    de: 'Deutsch',
    no: 'Norsk',
    tr: 'Türkçe',
    zh: '中文',
    es: 'Español',
    th: 'ไทย',
    cs: 'Čeština',
    is: 'Íslenska',
}
